import { cssVar } from '../../theme/variables.js';
import { keyframes, css } from 'styled-components';

const inAnimationMobileDrawer = keyframes([
  `from{transform:translateY(100%);opacity:0;}to{transform:translateY(0);opacity:1;}`
]);
const outAnimationMobileDrawer = keyframes([
  `from{transform:translateY(0);}to{transform:translateY(100%);}`
]);
const cssRadixPopoverContentOverride = css([
  `position:fixed;bottom:0;left:0;width:100%;will-change:transform;max-height:calc(100% - env(safe-area-inset-top,0px) - 1rem);transform:translateY(100%);opacity:0;&[data-state='open']{animation:`,
  ` 0.2s ease-out forwards !important;animation-delay:0.25s !important;}&[data-state='closed']{animation:`,
  ` 0.15s ease-out forwards !important;}div:has(> &){z-index:126 !important;transform:none !important;height:100%;width:100%;pointer-events:auto !important;&:before{position:fixed;content:'';display:block;top:0;left:0;width:100%;height:100%;background-color:`,
  `;will-change:opacity;top:0;}}`
], inAnimationMobileDrawer, outAnimationMobileDrawer, cssVar["color-bg-overlay"]);

export { cssRadixPopoverContentOverride, inAnimationMobileDrawer, outAnimationMobileDrawer };
//# sourceMappingURL=cssRadixPopoverOverride.js.map
